var youbora = require('youboralib')
var manifest = require('../../manifest.json')

youbora.adapters.Bitmovin = youbora.StandardAdapter.extend({
    getVersion: function() {
        return manifest.version + '-' + manifest.name + '-' + manifest.tech
    },

    getDuration: function() {
        return this.duration
    },

    getPosition: function() {
        return this.plugin.getAdapter().flags.isJoined ? 'mid' : 'pre'
    },

    getListenersList: function() {
        var EVENT = this.player.EVENT || bitmovin.player.EVENT
        var eventList = {}
        eventList[EVENT.ON_AD_CLICKED] = this.clickListener
        eventList[EVENT.ON_AD_ERROR] = this.errorListener
        eventList[EVENT.ON_AD_FINISHED] = this.endListener
        eventList[EVENT.ON_AD_LINEARITY_CHANGED] = null
        eventList[EVENT.ON_AD_MANIFEST_LOADED] = this.manifestListener
        eventList[EVENT.ON_AD_PLAYBACK_FINISHED] = this.endListener
        eventList[EVENT.ON_AD_SCHEDULED] = null
        eventList[EVENT.ON_AD_SKIPPED] = this.skipListener
        eventList[EVENT.ON_AD_STARTED] = this.joinListener
        eventList[EVENT.ON_AD_BREAK_FINISHED] = this.endListener
        eventList[EVENT.ON_AD_BREAK_STARTED] = this.playListener
        eventList[EVENT.ON_AD_QUARTILE] = this.quartileListener
        eventList[EVENT.ON_PAUSED] = this.pauseListener
        eventList[EVENT.ON_PLAYING] = this.playingListener
        return [{
            suscriber: 'addEventHandler',
            unsuscriber: 'removeEventHandler',
            events: eventList
        }]
    },

    playListener: function(e) {
        this.fireStart()
        this.fireResume()
    },

    pauseListener: function(e) {
        this.firePause()
    },

    playingListener: function(e) {
        this.fireResume()
    },

    joinListener: function(e) {
        this.duration = e.duration
        this.fireStart()
        this.fireJoin()
    },

    clickListener: function(e) {
        this.fireClick(e.clickThroughUrl)
    },

    endListener: function(e) {
        this.fireStop()
        this.duration = null
    },

    errorListener: function(e) {
        // 200, 303, 403, 404, 405, 900, 901 Advertisement
        if (e.code >= 200 && e.code <= 999) {
            this.fireError(e.code, e.message)
            this.fireStop()
            this.duration = null
        }
    },

    skipListener: function(e) {
        this.fireSkip()
        this.duration = null
    },

    manifestListener: function(e) {
        youbora.Log.error(e)
    },

    /*quartileListener: function (e) {
      var quartileNumber = 1
      if (e.quartile === "midpoint") {
        quartileNumber = 2
      } else if (e.quartile === "thirdQuartile") {
        quartileNumber = 3
      }
      this.fireQuartile(quartileNumber)
    }*/

})

module.exports = youbora.adapters.Bitmovin